/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EdictSelectionRequest
 */
export interface EdictSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof EdictSelectionRequest
     */
    sourceReference: string;
    /**
     * 
     * @type {string}
     * @memberof EdictSelectionRequest
     */
    fileNumber: string;
    /**
     * 
     * @type {string}
     * @memberof EdictSelectionRequest
     */
    clientId: string;
}

/**
 * Check if a given object implements the EdictSelectionRequest interface.
 */
export function instanceOfEdictSelectionRequest(value: object): value is EdictSelectionRequest {
    if (!('sourceReference' in value) || value['sourceReference'] === undefined) return false;
    if (!('fileNumber' in value) || value['fileNumber'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function EdictSelectionRequestFromJSON(json: any): EdictSelectionRequest {
    return EdictSelectionRequestFromJSONTyped(json, false);
}

export function EdictSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdictSelectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceReference': json['sourceReference'],
        'fileNumber': json['fileNumber'],
        'clientId': json['clientId'],
    };
}

export function EdictSelectionRequestToJSON(json: any): EdictSelectionRequest {
    return EdictSelectionRequestToJSONTyped(json, false);
}

export function EdictSelectionRequestToJSONTyped(value?: EdictSelectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceReference': value['sourceReference'],
        'fileNumber': value['fileNumber'],
        'clientId': value['clientId'],
    };
}

